<template>
    <div class="w-100">
        <listado-recargos-tabla 
          :data="data"
          :dataRechargeTypes="dataRechargeTypes"
        /> 
    </div>
</template>

<script>

import { mapState, mapActions } from "vuex";

import ListadoRecargosTabla from "../../../components/tablas/lineas/ListadoRecargosTabla";
import { getRecargos, getRechargeTypes } from "../../../constants/lineas";

export default {
data() {
    return {
      data: [],
      dataRechargeTypes: [],
      quantityRecharge: false 
    };
  },  
  components: {
    ListadoRecargosTabla
  },
  computed: {
    ...mapState("lineas", ["dataDatatableTarifasRecargos",'dataDatatableTarifasRecargosTypes']),
  },
  methods: {
    ...mapActions([ "AccionCambiar", 'ActionSetLoadingTable']),
    ...mapActions("lineas", [
      "actionSetDataDatatableTarifasRecargos",
      'actionSetFiltroTypeRecharge',
      'actionSetFiltroNaviera',
      'actionSetFiltroPol',
      'actionSetFiltroPod',
      'actionSetFiltroAtmosfera',
      'actionSetFiltroContainer',
      'actionSetFiltroCommodity',
      'actionSetFiltroUnityPayment',
      'actionSetDataDatatableTarifasRecargosTypes',
      'actionSetFilterStateRecargos',
      'actionSetRecargoTypeLoading'
    ]),

    actualizarURL() {
      let me = this;
      me.AccionCambiar(this.$route.path);
    },
    
    async getRecargos(){

        this.ActionSetLoadingTable(true);
        
        const { data } = await getRecargos() ;

        const data_table = !data.data ? [] : data.data.map( d => ({
            data: [
                d.naviera_name,
                d.naviera_departure,
                d.name,
                d.code,
                d.pol_name,
                d.pod_name,
                d.from_format,
                d.to_format,
                d.currency_name,
                d.neta,
                d.public_value,
                d.atmosphere_name,
                d.container_name,
                d.products_category_name,
                d.unit_payment_name
            ],
            data_complementaria: d 
        })) ;

        const { 
          filtroAtmosfera,
          filtroContainers,
          filtroNavieras,
          filtroPod,
          filtroPol,
          filtroTypeRecharge,
          filtroCommodity,
          filtroUnidadPago
        } = data.filtros ;

        this.actionSetFiltroTypeRecharge( filtroTypeRecharge );
        this.actionSetFiltroNaviera( filtroNavieras );
        this.actionSetFiltroPol( filtroPol );
        this.actionSetFiltroPod( filtroPod );

        this.actionSetFiltroAtmosfera( filtroAtmosfera );
        this.actionSetFiltroContainer( filtroContainers );
        this.actionSetFiltroCommodity( filtroCommodity );
        this.actionSetFiltroUnityPayment( filtroUnidadPago );

        this.actionSetDataDatatableTarifasRecargos( data_table );
        this.ActionSetLoadingTable(false);
    },
    async getRecargosTipos(){
      this.actionSetRecargoTypeLoading(true);
      const { data } = await getRechargeTypes() ;

      const data_table = !data.data ? [] : data.data.map( d => ({
          data: [ d.code, d.name, d.description.name, d.logistaas_code.name ],
          data_complementaria: d 
      })) ;

      this.actionSetDataDatatableTarifasRecargosTypes(data_table);
      this.actionSetRecargoTypeLoading(false);
    }
  },
  created() {
    this.actualizarURL();
    this.getRecargos(); 
    this.getRecargosTipos(); 

  },
  watch: {
    dataDatatableTarifasRecargos: function (_new) {
      if (_new) this.data = _new;
    },

    dataDatatableTarifasRecargosTypes: function (_new) {
      if (_new){
        this.actionSetFilterStateRecargos( null );
        this.dataRechargeTypes = _new;
        if( this.quantityRecharge ){
          this.getRecargos();
        }

        this.quantityRecharge = true ;
        
      } 
    },
  },
};
</script>